'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StyledCheckbox = require('./StyledCheckbox');

var _StyledCheckbox2 = _interopRequireDefault(_StyledCheckbox);

var _StyledFakeCheckbox = require('./StyledFakeCheckbox');

var _StyledFakeCheckbox2 = _interopRequireDefault(_StyledFakeCheckbox);

var _StyledLabel = require('./StyledLabel');

var _StyledLabel2 = _interopRequireDefault(_StyledLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = function (_Component) {
  (0, _inherits3.default)(Checkbox, _Component);

  function Checkbox() {
    (0, _classCallCheck3.default)(this, Checkbox);
    return (0, _possibleConstructorReturn3.default)(this, (Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).apply(this, arguments));
  }

  (0, _createClass3.default)(Checkbox, [{
    key: 'getProps',
    value: function getProps() {
      var props = (0, _objectWithoutProperties3.default)(this.props, []);

      // sanitze props for react props

      var keys = ['disabled', 'name', 'onKeyUp', 'onKeyDown', 'onKeyPress', 'onChange', 'onDragStart', 'onDrop', 'placeholder', 'tabIndex', 'type', 'value'];

      var inputProps = (0, _keys2.default)(props).reduce(function (prev, current) {
        var newPrev = (0, _extends3.default)({}, prev);
        if (keys.indexOf(current) !== -1) {
          newPrev[current] = props[current];
        }
        return newPrev;
      }, {});

      var checkChecked = props.defaultChecked === null ? { checked: props.checked } : { defaultChecked: props.defaultChecked };

      return (0, _extends3.default)({
        onChange: this.onChange
      }, inputProps, checkChecked);
    }

    /* eslint-disable jsx-a11y/label-has-for */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'label',
        null,
        _react2.default.createElement(_StyledCheckbox2.default, (0, _extends3.default)({ type: 'checkbox' }, this.getProps())),
        _react2.default.createElement(_StyledFakeCheckbox2.default, { jumbo: this.props.jumbo, small: this.props.small, disabled: this.props.disabled }),
        _react2.default.createElement(
          _StyledLabel2.default,
          { disabled: this.props.disabled },
          this.props.text
        )
      );
    }
  }]);
  return Checkbox;
}(_react.Component);

Checkbox.displayName = 'hui:Checkbox';
Checkbox.huiName = 'Checkbox';
Checkbox.propTypes = {
  className: _propTypes2.default.string,
  name: _propTypes2.default.string,
  text: _propTypes2.default.string,
  small: _propTypes2.default.bool,
  jumbo: _propTypes2.default.bool,
  defaultChecked: _propTypes2.default.bool,
  checked: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  disabled: _propTypes2.default.bool
};
Checkbox.defaultProps = {
  className: null,
  name: '',
  text: '',
  small: false,
  jumbo: false,
  defaultChecked: null,
  onChange: null,
  checked: null,
  disabled: false
};
exports.default = Checkbox;
//# sourceMappingURL=Checkbox.js.map


//////////////////
// WEBPACK FOOTER
// ../checkbox/lib/Checkbox.js
// module id = 684
// module chunks = 0